import FeedItemType from "./FeedItemType"

const FeedItemProperty = {
  [FeedItemType.POLL]: "poll",
  [FeedItemType.RECOGNITION]: "recognition",
  [FeedItemType.GROUP_RECOGNITION]: "groupCelebration"
}

export default FeedItemProperty
